import React from "react"
import styled from "styled-components"
import { useIntl } from "gatsby-plugin-react-intl"

import { Row, Col } from "../../components/Grid"
import Snippet from "../../components/Snippet"
import Spacer from "../../components/Spacer"

import { media, mixins } from "../../styles"

import chartMarketDe from "../../images/content/publications/mobility-study/chart-market-de.svg"
import chartMarketEn from "../../images/content/publications/mobility-study/chart-market-en.svg"
import chartLendingDe from "../../images/content/publications/mobility-study/chart-lending-de.svg"
import chartLendingEn from "../../images/content/publications/mobility-study/chart-lending-en.svg"

const Wrapper = styled.div`
  img {
    height: auto;
    max-width: 100%;
  }
`

const Content = styled.div`
  @media ${media.md} {
    display: flex;
    flex-flow: column;
    justify-content: center;
    height: 100%;
  }

  h2 {
    ${mixins.title3}
    margin-bottom: 30px;
    text-align: center;

    @media ${media.md} {
      text-align: left;
    }
  }

  p {
    ${mixins.copy4}
  }

  small {
    display: block;
    line-height: 1.4;
  }
`

const charts = {
  market: {
    de: chartMarketDe,
    en: chartMarketEn,
  },
  lending: {
    de: chartLendingDe,
    en: chartLendingEn,
  },
}

const EmbeddedFinanceStudyCharts = () => {
  const intl = useIntl()

  return (
    <Wrapper>
      <Row>
        <Col md="6">
          <Content>
            <h2>
              <Snippet id="studyMobilityMarket" field="header" />
            </h2>
            <Snippet id="studyMobilityMarket" field="text" md />
            <Spacer height={30} sm={50} md={0} />
          </Content>
        </Col>
        <Col sm="6" smOffset="3" md="5" mdOffset="1">
          <img
            alt={Snippet({
              id: "studyMobilityMarketImageAlttext",
              field: "header",
            })}
            src={charts.market[intl.locale] || charts.market.en}
            width={571}
            height={430}
          />
        </Col>
      </Row>
      <Spacer height={80} sm={50} md={100} lg={120} />
      <Row>
        <Col md="6" mdOrder="2" mdOffset="1">
          <Content>
            <h2>
              <Snippet id="studyMobilityLending" field="header" />
            </h2>
            <Snippet id="studyMobilityLending" field="text" md />
          </Content>
          <Spacer height={30} sm={50} md={0} />
        </Col>
        <Col
          sm="6"
          smOffset="3"
          md="5"
          mdOffset="0"
          mdOrder="1"
          lg="5"
          lgOffset="0"
        >
          <img
            alt={Snippet({
              id: "studyMobilityLendingImageAlttext",
              field: "header",
            })}
            src={charts.lending[intl.locale] || charts.lending.en}
            width={571}
            height={430}
          />
        </Col>
      </Row>
    </Wrapper>
  )
}

export default EmbeddedFinanceStudyCharts
